import { get } from './';
export const getSegments = () => get(`/api/v1/segments`);
